import Vue from 'vue';

import VueI18n from 'vue-i18n'; // 引入国际化的包

import elementEN from 'element-ui/lib/locale/lang/en'; // 引入饿了么的英文包

import elementZH from 'element-ui/lib/locale/lang/zh-CN'; // 引入饿了么的中文包

import elementTW from 'element-ui/lib/locale/lang/zh-TW'; // 引入饿了么的繁体包

import ElementLocale from 'element-ui/lib/locale';

import en from '@/lang/en.js';

import zh from '@/lang/zh.js';

Vue.use(VueI18n); // 全局注册国际化包

let lang = localStorage.getItem('lang');
let code = 'zh-CN';
if (lang) {
  code = lang;
}

const i18n = new VueI18n({
  locale: code, // 从cookie中获取语言类型 获取不到就是中文
  silentTranslationWarn: true,
  fallbackLocale: 'zh-CN',
  messages: {
    'en-US': {
      ...en, // 将en.js语言包引入

      ...elementEN // 将饿了么的英文语言包引入
    },

    'zh-CN': {
      ...zh, // 加载zh.js语言包引入

      ...elementZH // 将饿了么的中文语言包引入
    },
    'zh-TW': {
      ...elementTW // 将饿了么的繁体语言包引入
    },
  }
});
ElementLocale.i18n((key, value) => i18n.t(key, value));
export default i18n;



// WEBPACK FOOTER //
// ./src/lang/index.js